import React from 'react';
import PropTypes from 'prop-types';
import staticText from 'static/text_display.json';
import { TASK_FIELDS } from '../../../utils/formFields/task';
import BaseForm from '../../Base/BaseForm';

const TaskForm = ({
  editMode,
  closeForm,
  onChange,
  validationSchema,
  generalSection,
  detailedSection,
  initialValues,
  onEdit,
  onCreate,
  saveHoverText,
  formTitle,
  resetForm,
  setResetForm,
  resetValues,
  headerContent,
  allowToArchive,
  confirmPopup,
  persistentStateName,
  disablePresist,
  size,
}) => {
  return (
    <BaseForm
      size={size}
      imageType="Establishment"
      headerContent={headerContent}
      edit={editMode}
      initialValues={initialValues}
      formTitle={formTitle}
      saveHoverText={saveHoverText}
      closeForm={closeForm}
      onSubmit={editMode ? onEdit : onCreate}
      validationSchema={validationSchema}
      onChange={onChange}
      generalSection={generalSection}
      detailedSection={detailedSection}
      isImageMandatory={TASK_FIELDS.image.required}
      imageField={TASK_FIELDS.image.field}
      hoverText={staticText.cleaner_operational_view.task.create}
      resetForm={resetForm}
      setResetForm={setResetForm}
      resetValues={resetValues}
      allowToArchive={allowToArchive}
      confirmPopup={confirmPopup}
      persistentStateName={persistentStateName}
      disablePresist={disablePresist}
      // {...(!editMode && { enableReinitialize: true })}
    />
  );
};

TaskForm.propTypes = {
  editMode: PropTypes.bool,
  closeForm: PropTypes.func.isRequired,
  onCreate: PropTypes.func,
  onEdit: PropTypes.func,
  onChange: PropTypes.func,
  validationSchema: PropTypes.object,
  generalSection: PropTypes.array,
  detailedSection: PropTypes.array,
  initialValues: PropTypes.object,
  saveHoverText: PropTypes.string,
  size: PropTypes.string,
  persistentStateName: PropTypes.string,
  formTitle: PropTypes.string,
  resetForm: PropTypes.bool,
  setResetForm: PropTypes.func,
  resetValues: PropTypes.object,
  headerContent: PropTypes.object,
  confirmPopup: PropTypes.object,
  allowToArchive: PropTypes.bool,
  disablePresist: PropTypes.bool,
};

export default TaskForm;
